// extracted by mini-css-extract-plugin
export default {"container":"PricingTable_container__Nhuhz","tableWrapper":"PricingTable_tableWrapper__QIZRC","table":"PricingTable_table__XtXXQ","bodyType":"PricingTable_bodyType__n2yXf"};